export class CollegeWiseRegisterReport {
    public ID: number;
    public HashCode: string;
    public CollegeName: string;
    public CollegeCode: string;
    public TrustName: string;
    public Address: string;
    public MobileNo:string;
    public MailID:string;
    public Location:number;
    public Type:number;
    public StateID:number;
    public CityID:number;
    public Pincode:string;
    public fromDate:string;
    public toDate:string;
    public AcquiredDate:string;
    public CollegeID:number;

}